import {
  ProductListConfig,
  RenderableProduct,
  SkeletonProduct,
} from "../types/types";
import { componentMap as standardComponentMap } from "../product-card-components/componentMap";
import { componentMap as loaderComponentMap } from "../product-card-components/__loader__/LoaderComponent";
import styles from "./ProductCardSlot.module.scss";

type Props = {
  slotName: string;
  config: ProductListConfig;
  className?: string;
  product: RenderableProduct;
  index: number;
  bordered?: boolean;
  id?: string;
};

export const Slot = ({
  slotName,
  config,
  className,
  product,
  index: cardIndex,
  bordered = false,
  id,
}: Props) => {
  const components = config["product-card-slots"][slotName];

  if (!components || components.length < 1) {
    return null;
  }

  return (
    <div
      id={id}
      className={className}
      data-product-card-slot={slotName}
      data-testid={`product-card-slot-${slotName}`}
    >
      {components?.map((componentConfig, index) => {
        const componentKey = `${componentConfig.name}-${index}`;
        let Element = null;

        if (product.isSkeleton) {
          const Component = loaderComponentMap[componentConfig.name];

          if (Component) {
            Element = (
              <Component
                key={bordered ? undefined : componentKey}
                configProps={componentConfig.props}
                product={product as SkeletonProduct}
                index={cardIndex}
              />
            );
          }
        } else {
          const Component = standardComponentMap[componentConfig.name];

          if (Component) {
            Element = (
              <Component
                key={bordered ? undefined : componentKey}
                configProps={componentConfig.props}
                product={product}
                index={cardIndex}
              />
            );
          }
        }

        return Element ? (
          bordered ? (
            <div className={styles.wrapper} key={componentKey}>
              {Element}
            </div>
          ) : (
            Element
          )
        ) : null;
      })}
    </div>
  );
};
